<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <div
        v-if="
          mensagem !== '' && propView !== 'modal' && retornaSite() !== '7live'
        "
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <div
        v-if="retornaSite() == '7live' && propMeusDados && carregando"
        style="margin-bottom: 30px; margin-top: 30px"
      >
        <button type="button" class="btn btn-sm btn-warning">
          Carregando <img src="/assets/ajax-loader.gif" style="" />
        </button>
      </div>
      <div
        v-bind:style="{
          display:
            retornaSite() == '7live' && propMeusDados && !carregando
              ? 'block'
              : 'none',
        }"
        style="margin-top: 25px"
      >
        <div>
          <h3 class="text-secondary"><small>email</small></h3>
          <h3>{{ item.email }}</h3>
        </div>

        <div>
          <h3 class="text-secondary"><small>senha</small></h3>
          <input
            class="form-control"
            v-bind:class="{ 'is-invalid': itemErros.senha.status }"
            type="password"
            v-model="item.senha"
            @keyup="enterSalvar"
            placeholder="nova senha ..."
          />
          <div v-if="itemErros.senha.status" class="invalid-feedback">
            {{ itemErros.senha.mensagem }}
          </div>
        </div>
        <div v-if="mensagem !== '' && propView !== 'modal'">
          <h4 class="text-primary" style="margin-top: 15px">
            <small>Senha alterada</small>
          </h4>
        </div>
        <div style="margin-top: 20px">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="salvarItem()"
          >
            Alterar Senha
          </button>
        </div>
        <div style="margin-top: 20px">
          <h3 class="text-secondary">
            <span
              class="mr-2 text-dark"
              style="cursor: pointer"
              @click="
                item.gmt = item.gmt - 1;
                changeGmt();
              "
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-down-circle"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"
                /></svg></span
            ><span class="mr-2 prevent-select"><small>GMT</small></span>
            <span
              class="text-dark prevent-select"
              style="cursor: pointer"
              @click="
                item.gmt = item.gmt + 1;
                changeGmt();
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-up-circle"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
                />
              </svg>
            </span>
          </h3>
          <h3>
            <span class="mr-1 prevent-select">{{
              item.gmt >= 0 ? "+" : "-"
            }}</span
            ><span class="prevent-select"
              >{{ item.gmt >= 0 ? item.gmt : item.gmt * -1 }}
            </span>
          </h3>
        </div>
        <div
          style="margin-top: 20px"
          v-if="
            retornaTipoUsuario() !== 'Administrador' &&
            retornaTipoUsuario() !== 'Apresentador'
          "
        >
          <h3 class="text-secondary prevent-select"><small>crédito</small></h3>
          <h3 class="prevent-select">€ {{ item.credito }}</h3>
        </div>
        <div
          v-if="
            retornaTipoUsuario() == 'Administrador' ||
            retornaTipoUsuario() == 'Apresentador'
          "
          style="margin-top: 20px"
        >
          <h3 class="text-secondary prevent-select"><small>comissão</small></h3>
          <h3 class="prevent-select">
            € {{ formatCurrency(valorComissaoPendente) }}
          </h3>
        </div>
        <div
          style="margin-top: 20px"
          v-if="
            retornaTipoUsuario() !== 'Administrador' &&
            retornaTipoUsuario() !== 'Apresentador'
          "
        >
          <h3 class="text-secondary prevent-select">
            <small>vencimento</small>
          </h3>
          <h5
            v-if="
              propMeusDados &&
              propVencimento &&
              retornaSite() == '7live' &&
              item.plano !== null
            "
            style="margin-bottom: 20px"
          >
            Seu plano finaliza em {{ formatDateTimeSimple(item.plano.dataFim) }}
          </h5>
          <div
            v-if="
              propMeusDados &&
              propVencimento &&
              retornaSite() == '7live' &&
              item.plano == null
            "
            style="margin-bottom: 20px"
          >
            <h5 style="margin-bottom: 20px">Você não possuí um plano ativo</h5>
          </div>
        </div>
      </div>
      <div
        class="row"
        v-if="false && retornaSite() == 'Weddbets' && propMeusDados"
        style="margin-top: 10px"
      >
        <div class="col col-md-12 d-flex justify-content-center">
          <span class="text-center">
            <a
              clsas="d-flex justify-content-center"
              href="https://t.me/Wedd_Bll"
              style="width: 100%; text-decoration: none"
              ><i
                class="fa fa-telegram"
                style="font-size: 36px; color: #0088cc"
              ></i>
              <h5 class="text-secondary" style="min-width: 135px">
                weddbets
              </h5></a
            ></span
          ><span class="text-center" style="margin-left: 10px" v-if="false">
            <a
              clsas="d-flex justify-content-center"
              href="https://wa.me/qr/OQN6E6SM2PURM1"
              style="width: 100%; text-decoration: none"
              ><i
                class="fa fa-whatsapp"
                style="font-size: 36px; color: #34af23"
              ></i>
              <h5 style="color: black; min-width: 135px">
                <small>41 99936-4613</small>
              </h5></a
            ></span
          >
        </div>
      </div>
      <Dialog
        :id="propMeusDados ? 'dialogEditMeusDados' : 'dialogEdit'"
        titulo="Usuário"
        ref="dialog"
        :modal="
          propView == 'modal' || (retornaSite() == '7live' && propMeusDados)
        "
        :hideHeader="propView !== 'modal' || propMeusDados == false"
        tamanho="lg"
        :noClassFooter="true"
      >
        <div class="text-left">
          <div class="row" v-if="!propMeusDados && item._id == ''">
            <div class="col-md-12 text-center">
              <h5>Novo usuário</h5>
              <hr />
            </div>
          </div>

          <div
            class="row"
            v-if="
              retornaSite() === 'Share' && !propMeusDados && item._id !== ''
            "
          >
            <div class="col-md-12 text-center">
              <h5>Editando usuário</h5>
              <hr />
            </div>
          </div>

          <div
            class="row"
            v-if="
              retornaSite() !== 'Share' && !propMeusDados && item._id !== ''
            "
            style="margin-bottom: 20px"
          >
            <div class="col-md-12 text-center">
              <h5>Editando usuário</h5>
              <hr />
              <div
                class="d-flex justify-content-center"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  style="margin-right: 5px"
                  class="btn btn-sm"
                  v-bind:class="{
                    'btn-secondary': abaSelecionada == 'dados',
                    'btn-outline-secondary': abaSelecionada !== 'dados',
                  }"
                  @click="trocarAba('dados')"
                >
                  Dados
                </button>
                <button
                  v-if="retornaSite() === '7live'"
                  type="button"
                  style="margin-right: 5px"
                  class="btn btn-sm"
                  v-bind:class="{
                    'btn-secondary': abaSelecionada == 'creditos',
                    'btn-outline-secondary': abaSelecionada !== 'creditos',
                  }"
                  @click="trocarAba('creditos')"
                >
                  Créditos
                </button>
                <button
                  type="button"
                  style="margin-right: 5px"
                  class="btn btn-sm"
                  v-bind:class="{
                    'btn-secondary': abaSelecionada == 'planos',
                    'btn-outline-secondary': abaSelecionada !== 'planos',
                  }"
                  @click="trocarAba('planos')"
                >
                  Planos
                </button>
                <button
                  v-if="retornaSite() === '7live'"
                  type="button"
                  style="margin-right: 5px"
                  class="btn btn-sm"
                  v-bind:class="{
                    'btn-secondary': abaSelecionada == 'eventos',
                    'btn-outline-secondary': abaSelecionada !== 'eventos',
                  }"
                  @click="trocarAba('eventos')"
                >
                  Eventos
                </button>
                <button
                  v-if="retornaSite() == 'Weddbets'"
                  type="button"
                  style="margin-right: 5px"
                  class="btn btn-sm"
                  v-bind:class="{
                    'btn-secondary': abaSelecionada == 'indicacoes',
                    'btn-outline-secondary': abaSelecionada !== 'indicacoes',
                  }"
                  @click="trocarAba('indicacoes')"
                >
                  Indicações
                </button>
              </div>
            </div>
          </div>

          <div
            class="rowDados"
            v-bind:style="{
              display: abaSelecionada == 'dados' ? 'block' : 'none',
            }"
          >
            <div class="row">
              <div
                class="col-sm-6"
                v-if="
                  !propMeusDados &&
                  retornaSite() !== 'Stream1x2' &&
                  retornaSite() !== '7live'
                "
              >
                <div class="form-group row">
                  <label class="col-sm-12 col-form-label">Site</label>
                  <div class="col-sm-12">
                    <Combo
                      :itens="sites"
                      v-model="item.site"
                      :erro="itemErros.site.status"
                    />
                    <div v-if="itemErros.site.status" class="invalid-feedback">
                      {{ itemErros.site.mensagem }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-sm-6"
                v-if="
                  !propMeusDados &&
                  item._id !== '' &&
                  (retornaSite() == 'Weddbets' || retornaSite() == 'Bll')
                "
              >
                <div class="form-group row">
                  <label class="col-sm-12 col-form-label">Vencimento</label>
                  <div class="col-sm-12" style="margin-top: 8px">
                    <h6>{{ item.vencimento }}</h6>
                  </div>
                </div>
              </div>

              <div
                class="col-sm-6"
                v-if="
                  !propMeusDados &&
                  retornaSite() !== '7live' &&
                  retornaSite() !== 'Weddbets' &&
                  retornaSite() !== 'Bll'
                "
              >
                <div class="form-group row">
                  <label class="col-sm-12 col-form-label">Vencimento</label>
                  <div class="col-sm-12">
                    <input
                      class="form-control"
                      v-bind:class="{
                        'is-invalid': itemErros.vencimento.status,
                      }"
                      type="date"
                      v-model="item.vencimento"
                      @keyup="enterSalvar"
                    />
                    <div
                      v-if="itemErros.vencimento.status"
                      class="invalid-feedback"
                    >
                      {{ itemErros.vencimento.mensagem }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-group row"
              v-if="!propMeusDados && retornaSite() !== '7live'"
            >
              <label class="col-sm-12 col-form-label">Nome</label>
              <div class="col-sm-12">
                <input
                  class="form-control"
                  v-bind:class="{ 'is-invalid': itemErros.nome.status }"
                  type="text"
                  v-model="item.nome"
                  @keyup="enterSalvar"
                />
                <div v-if="itemErros.nome.status" class="invalid-feedback">
                  {{ itemErros.nome.mensagem }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-12 col-form-label">Email</label>
              <div class="col-sm-12">
                <input
                  class="form-control"
                  v-bind:class="{ 'is-invalid': itemErros.email.status }"
                  type="text"
                  v-model="item.email"
                  :disabled="propMeusDados"
                  @keyup="enterSalvar"
                />
                <div v-if="itemErros.email.status" class="invalid-feedback">
                  {{ itemErros.email.mensagem }}
                </div>
              </div>
            </div>
            <div class="form-group row" v-if="!propMeusDados">
              <label class="col-sm-12 col-form-label">Tipo de usuário</label>
              <div class="col-sm-12">
                <Combo
                  :itens="$global.tipos_usuarios()"
                  v-model="item.tipoUsuario"
                  :erro="itemErros.tipoUsuario.status"
                />
                <div
                  v-if="itemErros.tipoUsuario.status"
                  class="invalid-feedback"
                >
                  {{ itemErros.tipoUsuario.mensagem }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-12 col-form-label">Senha</label>
              <div class="col-sm-12">
                <input
                  class="form-control"
                  v-bind:class="{ 'is-invalid': itemErros.senha.status }"
                  type="password"
                  v-model="item.senha"
                  @keyup="enterSalvar"
                />
                <div v-if="itemErros.senha.status" class="invalid-feedback">
                  {{ itemErros.senha.mensagem }}
                </div>
              </div>
            </div>

            <div
              class="form-group row"
              v-if="!propMeusDados && retornaSite() == 'Weddbets'"
            >
              <div class="col-md-12 col-sm-12">
                <p class="text-center" style="margin-bottom: 5px">Indicação</p>
                <div
                  v-bind:style="{ display: item.indicacao == '' ? '' : 'none' }"
                >
                  <autocomplete
                    default-value=""
                    :search="filtroIndicacao"
                    :get-result-value="displayFiltroIndicacao"
                    @submit="selecionarFiltroIndicacao"
                    style="width: 100%"
                    ref="inputIndicacao"
                  ></autocomplete>
                </div>
                <div
                  v-bind:style="{
                    display: item.indicacao !== '' ? '' : 'none',
                  }"
                >
                  <p
                    class="text-center"
                    style="
                      color: blue;
                      text-decoration: underline;
                      cursor: pointer;
                    "
                    @click="removerFiltroIndicacao()"
                  >
                    {{ item.indicacaoEmail }} ({{
                      item.indicacaoRenovacoesTotal
                    }})
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group row" v-if="!propMeusDados">
              <label class="col-sm-12 col-form-label">Observacao</label>
              <div class="col-sm-12">
                <textarea
                  class="form-control"
                  v-bind:class="{ 'is-invalid': itemErros.observacao.status }"
                  v-model="item.observacao"
                />
                <div
                  v-if="itemErros.observacao.status"
                  class="invalid-feedback"
                >
                  {{ itemErros.observacao.mensagem }}
                </div>
              </div>
            </div>
            <div
              class="form-group row"
              v-if="propMeusDados && propVencimento && retornaSite() == '7live'"
            >
              <label class="col-sm-12 col-form-label text-center"
                >Crédito</label
              >
              <div class="col-sm-12 text-center">€ {{ item.credito }}</div>
            </div>

            <div
              class="form-group row"
              v-if="
                propMeusDados &&
                propVencimento &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live' &&
                item.planos === null
              "
            >
              <label class="col-sm-12 col-form-label text-center"
                >Vencimento</label
              >
              <div class="col-sm-12 text-center">
                {{ formatDate(item.vencimento) }}
              </div>
            </div>
            <div
              class="form-group row"
              v-if="
                propMeusDados &&
                propVencimento &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live' &&
                !item.planos === null &&
                item.plano == null
              "
            >
              <label
                v-if="retornaSite() == 'Weddbets' || retornaSite() == 'Bll'"
                label
                class="col-sm-12 col-form-label text-center"
                >Vencimento atual</label
              >
              <label
                v-if="retornaSite() == 'Stream1x2'"
                label
                class="col-sm-12 col-form-label text-center"
                >Vencimento</label
              >
              <div class="col-sm-12 text-center">-</div>
            </div>
            <div
              class="form-group row d-flex justify-content-center"
              v-if="
                propMeusDados &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live'
              "
            >
              <label class="col-sm-12 col-form-label text-center"
                >Selecione o fuso horário GMT</label
              >

              <div class="d-flex justify-content-center">
                <Combo
                  @change="changeGmt()"
                  :itens="[
                    {
                      id: '-12',
                      nome: 'GMT -12:00',
                    },
                    {
                      id: '-11',
                      nome: 'GMT -11:00',
                    },
                    {
                      id: '-10',
                      nome: 'GMT -10:00',
                    },
                    {
                      id: '-9',
                      nome: 'GMT -09:00',
                    },
                    {
                      id: '-8',
                      nome: 'GMT -08:00',
                    },
                    {
                      id: '-7',
                      nome: 'GMT -07:00',
                    },
                    {
                      id: '-6',
                      nome: 'GMT -06:00',
                    },
                    {
                      id: '-5',
                      nome: 'GMT -05:00',
                    },
                    {
                      id: '-4',
                      nome: 'GMT -04:00',
                    },
                    {
                      id: '-3',
                      nome: 'GMT -03:00',
                    },
                    {
                      id: '-2',
                      nome: 'GMT -02:00',
                    },
                    {
                      id: '-1',
                      nome: 'GMT -01:00',
                    },
                    {
                      id: '0',
                      nome: 'GMT +00:00',
                    },
                    {
                      id: '1',
                      nome: 'GMT +01:00',
                    },
                    {
                      id: '2',
                      nome: 'GMT +02:00',
                    },
                    {
                      id: '3',
                      nome: 'GMT +03:00',
                    },
                    {
                      id: '4',
                      nome: 'GMT +04:00',
                    },
                    {
                      id: '5',
                      nome: 'GMT +05:00',
                    },
                    {
                      id: '6',
                      nome: 'GMT +06:00',
                    },
                    {
                      id: '7',
                      nome: 'GMT +07:00',
                    },
                    {
                      id: '8',
                      nome: 'GMT +08:00',
                    },
                    {
                      id: '9',
                      nome: 'GMT +09:00',
                    },
                    {
                      id: '10',
                      nome: 'GMT +10:00',
                    },
                    {
                      id: '11',
                      nome: 'GMT +11:00',
                    },
                    {
                      id: '12',
                      nome: 'GMT +12:00',
                    },
                  ]"
                  v-model="item.gmt"
                />
              </div>
            </div>
            <div
              class="form-group row"
              v-if="
                propMeusDados &&
                (retornaSite() == 'Weddbets' || retornaSite() == 'Bll')
              "
            >
              <label class="col-sm-12 col-form-label text-center"
                >Escolha seu template</label
              >
              <div class="col-md-12 text-center">
                <button
                  type="button"
                  v-bind:class="{
                    'btn-secondary': $site == 'Weddbets',
                    'btn-outline-secondary': $site !== 'Weddbets',
                  }"
                  class="btn btn-sm"
                  @click="trocarTemplate('Weddbets')"
                  :disabled="$site == 'Weddbets'"
                >
                  Template 1
                </button>
                <button
                  type="button"
                  v-bind:class="{
                    'btn-secondary': $site == 'Bll',
                    'btn-outline-secondary': $site !== 'Bll',
                  }"
                  class="btn btn-sm ml-1"
                  @click="trocarTemplate('Bll')"
                  :disabled="$site == 'Bll'"
                >
                  Template 2
                </button>
              </div>
            </div>
            <div
              class="form-group row"
              v-if="
                propMeusDados &&
                (retornaSite() == 'Weddbets' || retornaSite() == 'Bll')
              "
            >
              <label class="col-sm-12 col-form-label text-center"
                >Dark Mode</label
              >
              <div class="col-md-12 text-center">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  @click="trocarDarkMode(true)"
                >
                  Sim
                </button>
                <button
                  type="button"
                  class="btn btn-sm ml-1 btn-outline-secondary"
                  @click="trocarDarkMode(false)"
                >
                  Não
                </button>
              </div>
            </div>
            <div
              class="form-group row"
              v-if="
                propMeusDados &&
                propVencimento &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live' &&
                item.plano !== null
              "
            >
              <label
                v-if="retornaSite() == 'Weddbets' || retornaSite() == 'Bll'"
                label
                class="col-sm-12 col-form-label text-center"
                >Vencimento atual</label
              >
              <label
                v-if="retornaSite() == 'Stream1x2'"
                label
                class="col-sm-12 col-form-label text-center"
                >Vencimento</label
              >
              <div class="col-sm-12 text-center">
                {{ formatDate(item.plano.dataFim) }}
              </div>
            </div>

            <div
              class="form-group row"
              v-if="
                propMeusDados &&
                propVencimento &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live' &&
                item.planosAgendados &&
                item.planosAgendados.length > 0
              "
            >
              <label class="col-sm-12 col-form-label text-center"
                >Próximos planos</label
              >

              <div
                class="col-sm-12 text-center"
                v-for="itemAgendado in item.planosAgendados"
                :key="itemAgendado._id"
                :item="itemAgendado"
              >
                <small
                  >{{ formatDate(itemAgendado.dataInicio) }} -
                  {{ formatDate(itemAgendado.dataFim) }}</small
                >
              </div>
            </div>
            <div class="text-center">
              <ListIndicacoes
                ref="listIndicacoesMeusDados"
                v-if="retornaSite() == 'Bll' && propMeusDados"
              />
            </div>
          </div>

          <div
            class="rowPacotes"
            v-bind:style="{
              display: abaSelecionada == 'planos' ? 'block' : 'none',
            }"
          >
            <div
              class="row"
              style="margin-bottom: 10px"
              v-if="retornaSite() !== 'Share'"
            >
              <div class="col-md-12 col-sm-12 text-center">
                <button
                  type="button"
                  class="btn btn-warning btn-sm"
                  @click="lancarPlanoCliente()"
                >
                  Lançar
                </button>
              </div>
            </div>

            <ListPlanosCliente
              ref="listPlanosCliente"
              :propUsuario="item._id"
              :propView="'usuario'"
              @item-excluido="calcularVencimento(null)"
            />
          </div>

          <div
            class="rowCreditos"
            v-bind:style="{
              display: abaSelecionada == 'creditos' ? 'block' : 'none',
            }"
          >
            <div class="row" style="margin-bottom: 10px">
              <div class="col-md-12 col-sm-12 text-center">
                <button
                  type="button"
                  class="btn btn-warning btn-sm"
                  @click="lancarCreditoUsuario()"
                >
                  Lançar
                </button>
              </div>
            </div>

            <ListCreditosUsuario
              ref="listCreditosUsuario"
              :propUsuario="item._id"
              :propView="'usuario'"
            />
          </div>

          <div
            class="rowEventos"
            v-bind:style="{
              display: abaSelecionada == 'eventos' ? 'block' : 'none',
            }"
          >
            <ListEventosUsuario
              ref="listEventosUsuario"
              :propUsuario="item._id"
              :propView="'usuario'"
            />
          </div>

          <div
            class="rowIndicacoes text-center"
            v-bind:style="{
              display: abaSelecionada == 'indicacoes' ? 'block' : 'none',
            }"
          >
            <ListIndicacoes
              ref="listIndicacoesUsuario"
              v-if="retornaSite() == 'Weddbets' && !propMeusDados"
              :renovacoes="item.afiliadoRenovacoes"
              @renovacoes="listIndicacoesRenovacoes"
              :usuario="item._id"
              :site="item.site"
              :propView="'usuario'"
            />
          </div>

          <div
            v-if="mensagem !== '' && propView == 'modal'"
            class="alert alert-success alert-dismissible fade show"
            role="alert"
          >
            <strong>{{ mensagem }}</strong>
          </div>
        </div>

        <template v-slot:rodape>
          <div class="row">
            <div
              class="col-md-12 col-sm-12 d-flex justify-content-center"
              style="align-items: center; padding: 0.75rem"
            >
              <button
                type="button"
                class="btn btn-outline-primary"
                style="margin-right: 5px"
                v-if="view == 'modal' && propMeusDados == false"
                data-dismiss="modal"
              >
                Fechar
              </button>
              <button
                v-if="
                  abaSelecionada == 'dados' || abaSelecionada == 'indicacoes'
                "
                type="button"
                class="btn btn-primary"
                @click="salvarItem()"
              >
                Salvar
              </button>
            </div>
          </div>
        </template>
      </Dialog>
      <EditPlanoCliente
        ref="editPlanoCliente"
        :propUsuario="item._id"
        @fechar="fecharPlanoCliente"
      />
      <EditCreditoUsuario
        ref="editCreditoUsuario"
        :propUsuario="item._id"
        @fechar="fecharCreditoUsuario"
      />
      <ListIndicacoes
        ref="listIndicacoesMeusDados"
        v-if="retornaSite() == 'Weddbets' && propMeusDados"
      />
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";
import Combo from "../components/Combo.vue";
import ListPlanosCliente from "../lists/ListPlanosCliente.vue";
import EditPlanoCliente from "../edits/EditPlanoCliente.vue";
import ListCreditosUsuario from "../lists/ListCreditosUsuario.vue";
import EditCreditoUsuario from "../edits/EditCreditoUsuario.vue";

import ListEventosUsuario from "../lists/ListEventosUsuario.vue";
import ListIndicacoes from "../lists/ListIndicacoes.vue";

import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";

export default {
  name: "EditUsuario",
  components: {
    Autocomplete,
    Dialog,
    Combo,
    ListPlanosCliente,
    EditPlanoCliente,
    ListCreditosUsuario,
    EditCreditoUsuario,
    ListEventosUsuario,
    ListIndicacoes,
  },
  props: {
    propMeusDados: { type: Boolean, default: false },
    propView: { type: String, default: "modal" },
    propVencimento: { type: Boolean, default: true },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    listIndicacoesRenovacoes(valor) {
      this.item.afiliadoRenovacoes = valor;
    },
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    trocarAba(aba) {
      this.abaSelecionada = aba;
    },
    async trocarTemplate(item) {
      await api.put("/usuario/template", { novoTemplate: item });
      localStorage.setItem("template", item);
      document.location.href = "/";
    },
    async trocarDarkMode(status) {
      localStorage.setItem("darkMode", status);
      document.location.href = "/";
    },
    async carregarItem(id) {
      //* Limpa os campos
      this.novo();

      //* Carrega os dados
      var itemEdit = {};

      if (this.propMeusDados) {
        const response = await api.get("/usuario/meus-dados");
        itemEdit = response.data.item;

        if (itemEdit.valorComissaoPendente) {
          this.valorComissaoPendente = itemEdit.valorComissaoPendente;
        }
      } else {
        const response = await api.get("/usuario/" + id);
        //* Verifica se econtrou
        if (response.data.itens.length > 0) {
          itemEdit = response.data.itens[0];
        }
      }

      this.item._id = itemEdit._id;
      this.item.site = itemEdit.site;
      this.item.email = itemEdit.email;
      this.item.senha = "";

      if (
        Object.prototype.hasOwnProperty.call(itemEdit, "gmt") &&
        Number.isInteger(itemEdit.gmt)
      ) {
        this.item.gmt = itemEdit.gmt;
      } else {
        if (this.retornaSite() == "7live") {
          this.item.gmt = 1;
        } else {
          this.item.gmt = -3;
        }
      }

      if (!this.propMeusDados) {
        this.item.nome = itemEdit.nome;
        this.item.tipoUsuario = itemEdit.tipoUsuario;
        this.item.observacao = itemEdit.observacao;

        if (itemEdit.indicacao && itemEdit.indicacao._id) {
          this.item.indicacao = itemEdit.indicacao._id;
          this.item.indicacaoEmail = itemEdit.indicacao.email;
          this.item.indicacaoRenovacoes = itemEdit.indicacaoRenovacoes;
          this.item.indicacaoRenovacoesTotal =
            itemEdit.indicacaoRenovacoesTotal;
        }

        this.item.afiliadoRenovacoes = itemEdit.afiliadoRenovacoes
          ? itemEdit.afiliadoRenovacoes
          : "1";

        this.$refs.listPlanosCliente.carregarItensUsuario(itemEdit._id);
        this.$refs.listCreditosUsuario.carregarItensUsuario(itemEdit._id);
        this.$refs.listEventosUsuario.carregarItensUsuario(itemEdit._id);
      } else {
        if (itemEdit.planos.length > 0) {
          this.item.planos = itemEdit.planos;
        }
      }

      if (
        !this.propMeusDados &&
        (this.retornaSite() == "Weddbets" || this.retornaSite() == "Bll")
      ) {
        await this.calcularVencimento(itemEdit);
      } else {
        var arrVencimento = itemEdit.vencimento.toString().split("T");

        if (arrVencimento.length > 0) {
          this.item.vencimento = arrVencimento[0];
        } else {
          this.item.vencimento = "";
        }
      }

      if (itemEdit.credito) {
        this.item.credito = itemEdit.credito;
      }

      if (itemEdit.plano) {
        this.item.plano = itemEdit.plano;
      }

      if (itemEdit.planosAgendados) {
        this.item.planosAgendados = itemEdit.planosAgendados;
      }

      if (this.retornaSite() == "Weddbets" && !this.propMeusDados) {
        this.$refs.listIndicacoesUsuario.filtroUsuarioIndicacao = itemEdit._id;
        this.$refs.listIndicacoesUsuario.carregarIndicacoes();
      }

      if (this.retornaSite() == "Weddbets" && this.propMeusDados) {
        this.$refs.listIndicacoesMeusDados.carregarIndicacoes();
      }
    },
    async calcularVencimento(itemEdit) {
      if (itemEdit == null) {
        const response = await api.get("/usuario/" + this.item._id);

        //* Verifica se econtrou
        if (response.data.itens.length > 0) {
          itemEdit = response.data.itens[0];
        }
      }

      if (itemEdit.idx_planosUltimo) {
        if (itemEdit.idx_planosCorrente) {
          this.item.vencimento = this.formatDate(
            itemEdit.idx_planosCorrente.dataFim
          );
        } else {
          this.item.vencimento = this.formatDate(
            itemEdit.idx_planosUltimo.dataFim
          );
        }

        if (
          itemEdit.idx_planosProximo &&
          itemEdit.idx_planosProximo.length > 0
        ) {
          this.item.vencimento =
            this.item.vencimento +
            " ... " +
            this.formatDate(
              itemEdit.idx_planosProximo[itemEdit.idx_planosProximo.length - 1]
                .dataFim
            );
        }
      } else {
        this.item.vencimento = this.formatDate(itemEdit.vencimento);
      }
    },
    async salvarItem() {
      this.mensagem = "";
      this.itemErros = util.errosLimpar(this.itemErros);

      if (this.item.email) {
        this.item.email = this.item.email.toLowerCase();
      }

      var apiRequest;

      var body = this.item;

      if (body.senha == "") {
        delete body.senha;
      }

      if (this.propMeusDados) {
        body.meusDados = true;
      }

      if (this.item._id == "") {
        apiRequest = await api.post("/usuario", body);
      } else {
        apiRequest = await api.put("/usuario/" + this.item._id, body);
        //console.log(apiRequest.data);
      }

      if (apiRequest.data.erro) {
        util.errosProcessar(this.itemErros, apiRequest.data.erros);
      } else {
        if (this.item._id === "") {
          this.carregarItem(apiRequest.data._id);
        } else {
          this.mensagem =
            "Usuário " +
            (this.item._id == "" ? "inserido" : "alterado") +
            " com sucesso!";
          this.$emit("save-item");
        }
      }
    },
    async changeGmt() {
      await api.put("/usuario/gmt", { gmt: parseInt(this.item.gmt) });
    },
    async novo() {
      this.mensagem = "";

      this.$set(this.item, "_id", "");
      this.$set(this.item, "site", this.retornaSite());
      this.$set(this.item, "nome", "");
      this.$set(this.item, "email", "");
      this.$set(
        this.item,
        "tipoUsuario",
        this.propMeusDados ? "" : "Assinante"
      );
      this.$set(this.item, "vencimento", "");
      this.$set(this.item, "gmt", this.retornaSite() == "7live" ? 0 : -3);
      this.$set(this.item, "credito", 0);
      this.$set(this.item, "plano", null);
      this.$set(this.item, "planos", null);
      this.$set(this.item, "observacao", "");

      this.$set(this.item, "senha", "");
      this.$set(this.item, "indicacao", "");
      this.$set(this.item, "indicacaoEmail", "");
      this.$set(this.item, "indicacaoRenovacoes", 0);
      this.$set(this.item, "indicacaoRenovacoesTotal", 1);
      this.$set(this.item, "afiliadoRenovacoes", "1");
      this.itemErros = util.errosLimpar(this.itemErros);

      this.$refs.listPlanosCliente.limpar();

      if (this.$refs.inputIndicacao) {
        this.$refs.inputIndicacao.value = "";
      }

      this.abaSelecionada = "dados";
      this.valorComissaoPendente = 0;
    },
    async enterSalvar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.salvarItem();
      }
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    emailMaskHide(email) {
      return util.emailMaskHide(email);
    },
    formatDateTimeSimple(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDateTimeSimple(data);
    },
    formatCurrency(data) {
      return util.formatCurrency(data);
    },
    lancarPlanoCliente() {
      this.$refs.dialog.fechar();
      this.$refs.editPlanoCliente.abrir();
    },
    lancarCreditoUsuario() {
      this.$refs.dialog.fechar();
      this.$refs.editCreditoUsuario.abrir();
    },
    fecharPlanoCliente() {
      this.$refs.listPlanosCliente.carregarItensUsuario(this.item._id);
      this.calcularVencimento(null);
      this.$refs.dialog.abrir();
    },
    fecharCreditoUsuario() {
      this.$refs.listCreditosUsuario.carregarItensUsuario(this.item._id);
      this.$refs.dialog.abrir();
    },
    selecionarFiltroIndicacao(result) {
      this.item.indicacao = result._id;
      this.item.indicacaoEmail = result.email;
      this.item.indicacaoRenovacoes = 0;
      this.item.indicacaoRenovacoesTotal = 1;
    },
    removerFiltroIndicacao() {
      this.item.indicacao = "";
      this.item.indicacaoEmail = "";
      this.item.indicacaoRenovacoes = 0;
      this.item.indicacaoRenovacoesTotal = 1;
    },
    filtroIndicacao(input) {
      //if (this.planos.length == 0) {
      //  return [];
      //}

      var filtros = "?_limit=10&_page=1";

      if (input !== "") {
        filtros += "&_all=" + input;
      }

      filtros += "&site=" + this.item.site;

      return new Promise((resolve) => {
        if (input.length < 3) {
          return resolve([]);
        }

        api.get("/usuario" + filtros).then((response) => {
          if (!response.data.erro) {
            resolve(response.data.itens);
          }
        });
      });
    },
  },
  async mounted() {
    this.sites.push({
      id: this.retornaSite(),
      nome:
        this.retornaSite() == "Stream1x2" ? "Stream 1x2" : this.retornaSite(),
    });

    if (this.retornaSite() == "Weddbets") {
      this.sites.push({ id: "Bll", nome: "Bll" });
    }

    await this.novo();

    if (this.propMeusDados) {
      await this.carregarItem(0);
    }

    this.view = this.propView;

    this.carregando = false;
  },
  computed: {},
  data: function () {
    return {
      item: {
        _id: "",
        site: "",
        nome: "",
        email: "",
        tipoUsuario: "",
        vencimento: "",
        observacao: "",
        gmt: 0,
        credito: 0,
        plano: null,
        planos: null,
        planosAgendados: Array(),
        senha: "",
        indicacao: "",
        indicacaoEmail: "",
        indicacaoRenovacoes: 0,
        indicacaoRenovacoesTotal: 1,
        afiliadoRenovacoes: "1",
      },
      itemErros: {
        site: { status: false, mensagem: "" },
        nome: { status: false, mensagem: "" },
        email: { status: false, mensagem: "" },
        tipoUsuario: { status: false, mensagem: "" },
        vencimento: { status: false, mensagem: "" },
        observacao: { status: false, mensagem: "" },
        senha: { status: false, mensagem: "" },
        indicacao: { status: false, mensagem: "" },
      },
      sites: [],
      tiposUsuario: [],
      abaSelecionada: "dados",
      view: "",
      mensagem: "",
      valorComissaoPendente: 0,
      carregando: true,
      displayFiltroIndicacao(result) {
        return result.email;
      },
    };
  },
};
</script>

<style></style>
